<script>
	export let margin = null
</script>

<ol class="{margin} ordered-list">
	<slot />
</ol>

<style lang="scss">
	.ordered-list {
		:global(ol) {
			margin: 2rem 0;
			padding-left: 0;
		}
		:global(ol) :global(li) {
			/* Style for numbers */
			counter-increment: css-counter 1;
			position: relative;
			display: flex;
			min-height: 4rem;
			margin: 1.5rem 0 1.5rem 4em;
			align-items: center;
			font-weight: 700;

			&:before {
				content: counter(css-counter);
				position: absolute;
				left: -5rem;
				width: 3.5rem;
				height: 3.5rem;
				color: #e20613;
				border-radius: 50%;
				border: 1px solid #e7e7e7;
				display: flex;
				font-size: 2rem;
				justify-content: center;
				align-items: center;
				font-weight: 700;
			}
		}
	}
</style>
